const rankingItems = [
  {
    rank: 1,
    title: '斗破苍穹',
    tag: '国漫',
    heat: '9.8',
    update: '今日更新第426话',
    desc: '萧炎晋升斗尊，丹塔大会全面开战',
  },
  {
    rank: 2,
    title: '鬼灭之刃',
    tag: '日漫',
    heat: '9.7',
    update: '今日更新第218话',
    desc: '无限城决战，炭治郎vs无惨终局之战',
  },
  {
    rank: 3,
    title: '我独自升级',
    tag: '韩漫',
    heat: '9.6',
    update: '昨日更新第179话',
    desc: '成振宇暗影军团横扫济州岛蚁穴',
  },
  {
    rank: 4,
    title: '完美世界',
    tag: '国漫',
    heat: '9.5',
    update: '今日更新第387话',
    desc: '石昊至尊骨大成，横推九天十地',
  },
  {
    rank: 5,
    title: '咒术回战',
    tag: '日漫',
    heat: '9.4',
    update: '今日更新第254话',
    desc: '五条悟解封，史上最强咒术师归来',
  },
];

const rankColors = ['text-primary-500', 'text-accent-500', 'text-accent-400', 'text-foreground-500', 'text-foreground-500'];
const rankIcons = ['ri-medal-fill', 'ri-medal-fill', 'ri-medal-line', '', ''];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">人气榜单</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            实时热度排行，发现全网最受欢迎的热门漫画作品
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankingItems.map((item, idx) => (
            <div
              key={item.rank}
              className={`flex items-center gap-4 p-4 md:p-5 border-b border-background-200/60 last:border-b-0 hover:bg-background-100/50 transition-colors cursor-pointer ${
                idx === 0 ? 'bg-primary-50/50 rounded-t-xl' : ''
              } ${idx === rankingItems.length - 1 ? 'rounded-b-xl' : ''}`}
            >
              {/* Rank */}
              <div className="w-10 h-10 flex items-center justify-center shrink-0">
                {idx < 3 ? (
                  <i className={`${rankIcons[idx]} text-2xl ${rankColors[idx]}`}></i>
                ) : (
                  <span className="text-lg font-bold text-foreground-400">{item.rank}</span>
                )}
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-heading text-sm md:text-base text-foreground-950 whitespace-nowrap">{item.title}</h3>
                  <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">{item.tag}</span>
                </div>
                <p className="text-xs md:text-sm text-foreground-500 line-clamp-1">{item.desc}</p>
              </div>

              {/* Heat & Update */}
              <div className="text-right shrink-0">
                <div className="flex items-center gap-1 justify-end mb-1">
                  <i className="ri-fire-line text-sm text-primary-500"></i>
                  <span className="text-sm font-bold text-primary-500">{item.heat}</span>
                </div>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.update}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}